module.exports = __webpack_public_path__ + "1ed1fb4107d9dda397cdf55f78c18098.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-15.png
// module id = 1784
// module chunks = 0